import { Box, Button, Center, Text } from "@chakra-ui/react";
import { RevealVertically } from "@raiden/library/components/Animations/RevealVertically";
import { RGrid } from "@raiden/library/components/RGrid";
import { POSTS_TYPE_VALUE_ASSOCIATION } from "@raiden/library/constants/posts";
import { useSearchInfiniteContext } from "@raiden/library/contexts/SearchInfinite/useSearchInfiniteContext";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { Fragment, memo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { DataHandlerInfinite } from "../../../../components/DataHandlerInfinite";
import { Icon } from "../../../../components/Icon";
import { Splash } from "../../../../components/Splash";
import { Item } from "./Item";

export const Results = memo(function Results() {
  const intl = useIntl();

  const [isAssociation, setIsAssociation] = useState(false);

  /** @type {import("@raiden/library/contexts/SearchInfinite/useSearchInfiniteContext").UseSearchInfiniteReturn<import(".").PostsSearchFormValues, import("@raiden/library/types/Post").Post[]>} */
  const {
    swrInfiniteResponse,
    reset,
    isDirty,
    form: { setValue },
  } = useSearchInfiniteContext();

  return (
    <DataHandlerInfinite
      swrInfiniteResponse={swrInfiniteResponse}
      noResult={
        <Splash
          src={generateFrontPath({
            id: "@front.internal-assets",
            parameters: { filePath: "illustrations/not-found.svg" },
          })}
          title={intl.formatMessage({ defaultMessage: "Aucun résultat" })}
          description={intl.formatMessage({
            defaultMessage:
              "Nous sommes désolés, aucun résultat de correspond à votre recherche.",
          })}
          addon={
            isDirty ? (
              <Center>
                <Button
                  onClick={reset}
                  colorScheme="brandPrimary"
                  backgroundColor="brandPrimary.700">
                  <Text as="span" variant="button" color="#fff">
                    <FormattedMessage defaultMessage="Réinitialiser la recherche" />
                  </Text>
                </Button>
              </Center>
            ) : undefined
          }
        />
      }>
      {(pages) => (
        <Box>
          <RGrid
            gridGap="1.5rem"
            minCellWidth={isAssociation ? "400px" : "250px"}>
            {pages.map((page, indexPage) => {
              return (
                <Fragment key={indexPage}>
                  {page.data?.map((post, indexPost) => {
                    setIsAssociation(
                      post.type === POSTS_TYPE_VALUE_ASSOCIATION,
                    );
                    return (
                      <Item
                        setValue={setValue}
                        key={indexPost}
                        post={post}
                        isFirst={
                          indexPage === 0 && indexPost === 0 && !isAssociation
                        }
                      />
                    );
                  })}
                </Fragment>
              );
            })}
          </RGrid>

          <RevealVertically isVisible={pages.length < pages[0].meta.last_page}>
            <Center pt="1rem">
              <Button
                onClick={() => {
                  swrInfiniteResponse.setSize((size) => size + 1);
                }}
                isLoading={swrInfiniteResponse.isValidating}
                rightIcon={
                  <Icon icon="ms_expand_more" size="1.5rem" color="gray.400" />
                }
                variant="ghost"
                colorScheme="brandPrimary">
                <Text as="span" variant="button">
                  <FormattedMessage defaultMessage="Voir plus de résultats" />
                </Text>
              </Button>
            </Center>
          </RevealVertically>
        </Box>
      )}
    </DataHandlerInfinite>
  );
});
